<template>
  <div class="m_home">
    <div class="m_bg">
      <img src="@/assets/m_bg.png" class="m_bg_img" />
      <img src="@/assets/m_bg_title.png" class="m_bg_title" />
    </div>
    <div class="m_main">
      <van-search
        v-model="value"
        shape="round"
        placeholder="请在此输入要办事项的关键字"
        @search="onSearch"
        @cancel="onCancel"
        class="m_home_search"
      />
      <div class="main_content">
        <div class="content_li" @click="jumpPage(10)">
          <img src="@/assets/m_stu.svg" />
          <div>学生</div>
        </div>
        <div class="content_li" @click="jumpPage(11)">
          <img src="@/assets/m_tea.svg" />
          <div>教师</div>
        </div>
        <div class="content_li" @click="jumpPage(12)">
          <img src="@/assets/m_manage.svg" />
          <div>管理人员</div>
        </div>
        <div class="content_li" @click="jumpPage(13)">
          <img src="@/assets/m_gra.svg" />
          <div>毕业校友</div>
        </div>
      </div>
    </div>
    <div class="m_bottom">版权所有 © 2021 河南大学教务处</div>
  </div>
</template>

<script>
export default {
  name: "m_home",
  data() {
    return {
      //搜索框中的值
      value: "",
    };
  },
  methods: {
    //跳转页面相关
    jumpPage(role) {
      console.log("要跳转到的页面是menu,角色是", role);
      switch (role) {
        case 10:
          this.$store.commit("whichRole", "学生事项");
          this.$store.commit("roleCode", 10);
          console.log(this.$store.state.role);
          break;
        case 11:
          this.$store.commit("whichRole", "教师事项");
          this.$store.commit("roleCode", 11);
          break;
        case 12:
          this.$store.commit("whichRole", "管理人员");
          this.$store.commit("roleCode", 12);
          break;
        case 13:
          this.$store.commit("whichRole", "毕业校友");
          this.$store.commit("roleCode", 13);
          break;
      }
      this.$router.replace("./m_menu");
    },
    //搜索时触发
    onSearch: function () {
      console.log("触发了search");
      if (this.value == "") {
        console.log("输入内容为空 不跳转");
      } else {
        this.$store.commit("searchCTN", this.value);
        console.log("首页搜索填入的内容", this.$store.state.searchCTN);
        this.$router.replace("./m_search");
      }
    },
    //搜索取消时触发
    onCancel: function () {
      console.log("触发了cancel");
    },
    //调接口统一地
    goInterface(whichType) {
      switch (whichType) {
        case "inSearch":
          searchByKeyword(this.value, this.pagenum).then((result) =>
            console.log(result)
          );
          break;
      }
    },
  },
};
</script>

<style scoped>
.m_home {
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
}
.m_home .m_bg {
  position: relative; /* 让父元素相对定位，子元素可使用绝对定位 */
  width: 100%;
  height: auto;
}
.m_home .m_bg_img {
  width: 100%;
  height: auto;
}
.m_home .m_bg_title {
  width: 56%;
  height: auto;
  position: absolute; /* 绝对定位，使其相对于父元素定位 */
  top: 20%; /* 垂直居中 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 通过transform调整偏移，完美居中 */
  z-index: 1; /* 保证在 m_bg_img 之上 */
}
.m_home .m_main {
  position: absolute; /* 绝对定位，使其相对于父元素定位 */
  top: 25%; /* 垂直居中 */
  left: 0%;
  width: 100%;
  height: 80%;
  z-index: 1;
  /* background: #fff; */
}
.m_main .m_home_search {
  /* 自定义外部容器样式 */
  width: 90%; /* 自定义宽度 */
  margin: 0 auto; /* 居中显示 */
  background: rgba(255, 255, 255, 0);
}
.m_home_search .van-search__input {
  background-color: #f5f5f5; /* 输入框背景色 */
  border-radius: 10px; /* 自定义圆角 */
  padding: 10px 15px; /* 自定义内边距 */
  font-size: 16px; /* 自定义字体大小 */
  color: #333; /* 自定义字体颜色 */
}
.m_home_search .van-search__label {
  margin-left: auto; /* 让图标靠右 */
  margin-right: 10px; /* 调整右边距 */
  padding-left: 0; /* 移除默认内边距 */
}

.m_home_search .van-search__action {
  color: #ff5722;
}
.main_content {
  display: flex; /* 使用 Flexbox 布局 */
  flex-wrap: wrap;
  overflow: hidden;
  top: 31%;
  /* height: 100%; */
  /* padding-bottom: auto; */
  margin: 0 20px;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;
}
.content_li {
  width: calc(50% - 6%); /* 设置为 50% 减去 margin 的总和 */
  height: auto;
  margin: 3%; /* 添加外边距以间隔 */
  background: linear-gradient(135deg, #f1f7fd 0%, #dfedf9 100%);
  border-radius: 4px 4px 0px 0px;
  height: 0;
  padding-bottom: 50%;
  position: relative; /* 让子元素相对于这个元素定位 */
  cursor: pointer; /* 鼠标悬停时显示手指图标 */
  position: relative;
}
.content_li img {
  width: 33%;
  height: 33%;
  position: absolute;
  top: 25%;
  left: 33%;
}
.content_li div {
  width: 100%;
  height: 33%;
  position: absolute;
  top: 54%;
  left: 0;
  text-align: center;
  font-weight: 300;
  font-size: 24px;
  color: #00589f;
  line-height: 72px;
}
.m_bottom {
  position: absolute;
  top: 93%;
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 20px;
  color: #999999;
  line-height: 48px;
}
/* 中间四个对象布局开始 */
.oopBox {
  overflow: hidden;
}

.theoop {
  width: 44vw;
  height: 44vw;
  background-color: whitesmoke;
  float: left;
}
.oop1 {
  margin-left: 4vw;
  margin-right: 1vw;
  margin-top: 10vw;
  background: url("../../assets/student.png");
  background-size: 44vw;
}
.oop2 {
  margin-left: 2vw;
  margin-right: 1vw;
  margin-top: 10vw;
  background: url("../../assets/teacher.png");
  background-size: 44vw;
}
.oop3 {
  margin-left: 4vw;
  margin-right: 1vw;
  margin-top: 2vw;
  background: url("../../assets/manage.png");
  background-size: 44vw;
}
.oop4 {
  margin-left: 2vw;
  margin-right: 1vw;
  margin-top: 2vw;
  background: url("../../assets/graduate.png");
  background-size: 44vw;
}
/* 中间四个对象布局结束 */

/* 最下面版权信息开始 */
.inBTM {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 55px;
  line-height: 55px;
  /* background-color: whitesmoke; */
  background-color: #09c;
  color: white;
  text-align: center;
  font-size: 14px;
}
/* 最下面版权信息结束 */
</style>
